import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-145">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm animate-fadeIn" onClick={onClose} aria-hidden="true" data-id="element-146" />

      {/* Modal Content */}
      <div className="relative bg-white rounded-lg shadow-2xl max-w-3xl w-full max-h-[90vh] flex flex-col animate-slideUp" data-id="element-147">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-148">
          <h2 id="modal-title" className="font-heading text-3xl md:text-4xl text-blueprint-blue" data-id="element-149">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Cerrar modal" data-id="element-150">
            <XIcon className="w-6 h-6 text-industrial-gray" data-id="element-151" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="overflow-y-auto p-6 md:p-8" data-id="element-152">
          <div className="prose prose-gray max-w-none" data-id="element-153">{children}</div>
        </div>
      </div>
    </div>;
}